import * as React from 'react';
import * as Redux from 'redux';
import * as _ from 'lodash';
import { fetchResults } from '../../actions/results'
import { setSearchTerm, setPage } from '../../actions/index';
import { IState } from '../../reducers/index'
import { ISearchResult, IResults } from '../../state-helpers/search-results';
import { SearchResultsInfo } from '../search-results/search-results-info';
import { ISearchCriteria } from '../../state-helpers/search-criteria';
import { IPage } from '../../state-helpers/page';
import { ResultsCountMessage } from '../../../global/components/results/results-count-msg';
import { addUrlProps, UrlQueryParamTypes, subquery, multiPushInUrlQuery, pushInUrlQuery } from 'react-url-query';
import { connect } from 'react-redux';
import { nodeListToArray } from '../../../../Static/javascript/helpers/nodeListToArray'

export interface ISearchBarProps {
    dispatch: Redux.Dispatch<IState>;
    totalResults: number;
    showingResults: ISearchResult[];
    pageModel: IPage;
    searchTerm: string;
    onSearchTermChanged(searchTerm: string): void;
    loading: boolean;
}

const urlPropsQueryConfig = {
    queryCurrentSearchTerm: { type: UrlQueryParamTypes.string, queryParam: "k" },
}

function mapStateToProps(state, props) {
    return {
        searchTermProp: state.searchTerm,
    };
}

/**
 * Standard react-redux mapDispatchToProps
 */
function mapDispatchToProps(dispatch) {
    return {
        setSearchTermProps: (query) => dispatch(setSearchTerm(query)),
    };
}

interface QueryProps {
    queryCurrentSearchTerm: string;
}

type SearchBarProps = ISearchBarProps & QueryProps;

export class SearchBar extends React.Component<SearchBarProps, any> {
    /**
     * Function to read search term from URL without reading state props
     */
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let e = document.getElementById('txt_search') as HTMLInputElement;
        this.resultsNullCheck(e.value);
    }

    getDefaultValue() {

        var query = window.location.search;
        var vars = query.split(/[\&\?/]/);

        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i];

            if (_.startsWith(pair, "k=")) {
                let phrase = decodeURIComponent(pair.split('=')[1]);

                if (phrase.indexOf('+')) {
                    phrase = phrase.split('+').join(' ');
                }

                return phrase;
            }
        }

        return this.props.searchTerm;
    }

    maxCharacters = 243; // BestBets triggers an error if term length exceeds this

    searchClick(e) {
        this.search();
    }

    search(term = null) {
        if (typeof (term) === 'undefined' || term === null)
            term = this.props.searchTerm;
        this.props.dispatch(setPage(1));
        this.props.dispatch(fetchResults(false));
        (document.getElementById('txt_search') as HTMLInputElement).value = term;
        multiPushInUrlQuery({ k: term, page: '1' });
    }

    inputChange(e) {
        if (e.target.value != '') {
        this.props.onSearchTermChanged(e.target.value);
        }
        this.resultsNullCheck(e.target.value);
    }

    searchClear(e) {
        multiPushInUrlQuery({ k: '', page: '1' });
        this.props.onSearchTermChanged('');
        const iconClose = document.querySelector('[data-search-input] button');
        const el = (document.querySelector('[data-search-input] input') as HTMLInputElement);
        el.value = '';
        el.focus();
        iconClose.classList.add('hide');
    }


    resultsNullCheck(value) {
        const iconClose = document.querySelector('[data-search-input] button');
        if (value != '') {
            iconClose.classList.remove('hide');
        }
        else {
            iconClose.classList.add('hide');
        }
    }

    /// <summary>
    /// Intercepts special keys that handle autocomplete scrolling and selection
    /// </summary>
    checkKeyPress(e) {
        switch (e.keyCode) {
            //Enter key
            //If an autocomplete option is selected, change the search text to that, otherwise submit
            case 13: {
                this.search(this.props.searchTerm);
            }
        }
    }

    render() {
        let boundClick = this.searchClick.bind(this);
        let boundChange = this.inputChange.bind(this);
        let boundSearchClear = this.searchClear.bind(this);
        let defaultValue = this.getDefaultValue.bind(this)();
        let boundKeyPress = this.checkKeyPress.bind(this);
        let resultsNullCheck = this.resultsNullCheck.bind(this);

        return (
            <div className="search-bar-container">

                <div className="search-bar">
                    <div className="search-bar-area">
                        <div className="search-bar-area-input">
                            <label className="visually-hidden" htmlFor="txt_search">Search Text</label>
                            <div className="search-bar-area-input-group" data-search-input>
                                <input type="text" name="txt_search" id="txt_search" aria-label="Search Text" placeholder="Search AMTA" maxLength={this.maxCharacters} onInput={boundChange} onKeyDown={boundKeyPress} defaultValue={defaultValue} />
                                <button className="un-btn search-bar-area-input-clear hide" onClick={boundSearchClear}>
                                    <svg className="svg-icon" aria-hidden="true" focusable="false">
                                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-close" />
                                    </svg>
                                    <span className="visually-hidden">Clear Search</span>
                                </button>
                            </div>
                        </div>
                        <div className="search-bar-area-button-container">
                            <button className="search-bar-area-button-container-submit" onClick={boundClick}>Search</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export var ConnectedSearchBar = addUrlProps({ urlPropsQueryConfig })(connect(mapStateToProps, mapDispatchToProps)(SearchBar));
